module.exports = __webpack_public_path__ + "static/media/tn.98351bcb.svg";